import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import VerticalLayout from "../Layouts/index";
import { authProtectedRoutes } from "./allRoutes";
import ProtectedRoute from "./ProtectedRoute";
import { getDefaultRoute } from "../pages/Caisse/defaultRoute";
import { useAuth } from '../Provider/AuthProvider';


const Index = () => {
    const { allowedInterfaces } = useAuth();

    return (
        <Routes>
            <Route>
                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        key={idx}
                        path={route.path}
                        element={
                            <VerticalLayout>
                                <ProtectedRoute
                                    component={route.component}
                                    requiredInterface={route.requiredInterface}
                                />
                            </VerticalLayout>
                        }
                    />
                ))}
            </Route>
            <Route
                path="*"
                element={<Navigate to={getDefaultRoute(allowedInterfaces)} replace />}
            />
        </Routes>
    );
};

export default Index;




//import React from 'react';
//import { Routes, Route } from "react-router-dom";
//import { useAuth } from '../Provider/AuthProvider';

////Layouts
//import VerticalLayout from "../Layouts/index";

////routes
//import { authProtectedRoutes } from "./allRoutes";

//const Index = () => {
//    const { allowedInterfaces } = useAuth();

//    const filteredRoutes = authProtectedRoutes.filter(route => {

//        if (!allowedInterfaces || allowedInterfaces.length === 0) {
//            return false;
//        }


//        if (['/profile', '/logout', '/', '*', '/introuvable', '/dev-access'].includes(route.path)) {
//            return true;
//        }

//        const interfaceName = route.path.replace('/', '');

//        return allowedInterfaces.includes(interfaceName);
//    });

//    return (
//        <React.Fragment>
//            <Routes>
//                {filteredRoutes.map((route, idx) => (
//                    <Route
//                        path={route.path}
//                        element={<VerticalLayout>{route.component}</VerticalLayout>}
//                        key={idx}
//                    />
//                ))}
//            </Routes>
//        </React.Fragment>
//    );
//};test

//export default Index;